module.exports = __webpack_public_path__ + "img/loading.0d2493be.gif";